export const prod = true;
export const url = 'https://api3.app.ihuizhua.com/';
export const CloudUrl = 'https://cloudgame.ihuizhua.com/#/';